import pick from "reassemble/lib/utils/pick";
export { pick };
export default pick;

//# sourceMappingURL=pick.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/utils/pick.js
// module id = 223
// module chunks = 0